import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/science-and-technology-policy-research/page.tsx");
